module.exports = __webpack_public_path__ + "img/jifen13.c01bf91b.png";